import React, {Component} from 'react'
import {Configure, Index, InstantSearch} from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'
import AlgoliaCollectionFilters from '../collection/filters'
import AlgoliaCollectionResults from '../collection/results'
import CustomSearchBar from './searchBar'
import StateResults from './searchBar/state-results'
import ArticleResults from './article-results'
import ArticleFilters from './article-filters'
import PageResults from './page-results'
import {getUrlParameterByName, pushNewUrl, replaceUrlParameter,} from '../../../modules/utils'
import {ALGOLIA_COLLECTION_FILTER_RULES, API_KEY, APP_ID, getShopifyAlgoliaIndex, HITS_PER_RESULTS,} from '../config'

import {LoadingIndicator, SearchUiViewButtonList} from './helpers'

export default class AlgoliaSearch extends Component {
  constructor(props) {
    super(props)
    this.algoliaConfig = getShopifyAlgoliaIndex()
    this.state = {
      resultsIndex: this.algoliaConfig.products,
      resultsList: this.algoliaConfig.product,
      searchValue: this.props.query,
      view: getUrlParameterByName(`view`) || `product`,
      viewTitle: `Products`,
      dropdown: `product`,
      productResults: 0,
      articleResults: 0,
      pageResults: 0,
      activeRefinements: 0,
      activeAlgoliaIndex: this.algoliaConfig.products,
      isLoading: true,
    }

    this.setNavigationLevel = this.setNavigationLevel.bind(this)
    this.changeResultsIndex = this.changeResultsIndex.bind(this)
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.changeResultsAmount = this.changeResultsAmount.bind(this)
    this.changeView = this.changeView.bind(this)
    this.setActiveView = this.setActiveView.bind(this)
    this.setNumberRefinements = this.setNumberRefinements.bind(this)

    const algoliaClient = algoliasearch(APP_ID, API_KEY)
    this.searchClient = {
      search(requests) {
        if (requests.every(({ params }) => !params.query)) {
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
            })),
          })
        }

        return algoliaClient.search(requests)
      },
    }

    this.configureFilters = ALGOLIA_COLLECTION_FILTER_RULES
  }

  componentDidMount() {
    setTimeout(() => {
      this.setActiveView()
    }, 800)
  }

  createMarkup(value) {
    return { __html: value }
  }

  setNumberRefinements(number) {
    this.setState({
      activeRefinements: number,
    })
  }

  toggleDropdown(handle) {
    const newDropdown = this.state.dropdown === handle ? null : handle
    this.setState(prevState => {
      return {
        dropdown: newDropdown,
      }
    })
  }

  changeResultsAmount(results) {
    this.setState(results)

    if (results.productResults === 0 && results.articleResults > 0) {
      this.setState({ view: `article` })
    } else if (
      results.productResults === 0 &&
      results.articleResults === 0 &&
      results.pageResults > 0
    ) {
      this.setState({ view: `page` })
    } else {
      this.setState({ view: `product` })
    }

    pushNewUrl(
      replaceUrlParameter(window.location.href, `view`, this.state.view)
    )

    return
  }

  setNavigationLevel(level) {
    this.setState({
      navigationLevel: level,
    })
  }

  changeResultsIndex(index) {
    this.setState({
      resultsIndex: index,
    })
  }

  changeView(view) {
    let viewTitle = `Products`
    if (view == `article`) {
      viewTitle = `Resources`
    } else if (view == `page`) {
      viewTitle = `Explore SilverChef`
    }

    this.setState({
      viewTitle,
      view,
      dropdown: ``,
    })

    pushNewUrl(replaceUrlParameter(window.location.href, `view`, view))
  }

  openFilters() {
    const element = document.getElementById(`sidebar-content`)
    if (element.classList.contains(`sidebar-mobile-view`)) {
      element.classList.remove(`sidebar-mobile-view`)
    } else {
      element.classList.add(`sidebar-mobile-view`)
    }
  }

  getFirstOrActiveView({
    uiViews,
    activeView,
    startingIndex = 0,
    fallbackView = `product`,
  }) {
    const hasPositiveResults = activeView && activeView.results >= 1
    let runCount = startingIndex

    if (runCount > uiViews.length) {
      this.changeView(fallbackView)
      this.setState({ isLoading: false })
      return
    }

    if (hasPositiveResults) {
      this.changeView(activeView.name)
      this.setState({ isLoading: false })
      return
    }

    runCount++
    this.getFirstOrActiveView({
      uiViews,
      activeView: uiViews[runCount],
      startingIndex: runCount,
    })
  }

  setActiveView() {
    const uiViews = [
      {
        name: `product`,
        results: this.state.productResults,
      },
      {
        name: `article`,
        results: this.state.articleResults,
      },
      {
        name: `page`,
        results: this.state.pageResults,
      },
    ]
    this.getFirstOrActiveView({ uiViews, activeView: uiViews[0] })
  }

  render() {
    const { navigation } = this.props
    const {
      dropdown,
      view,
      viewTitle,
      productResults,
      articleResults,
      pageResults,
      activeAlgoliaIndex,
      isLoading,
      searchValue,
    } = this.state

    return (
      <div>
        <InstantSearch
          indexName={activeAlgoliaIndex}
          searchClient={this.searchClient}
        >
          <div className="border-top border-bottom padding-top-6x small-padding-top-2x">
            <div
              className={`search-template xlarge ${
                dropdown === `searchTypes` ? `active-dropdown` : ``
              }`}
            >
              <CustomSearchBar
                onChange={value => this.setState({ value })}
                searchValue={searchValue}
                delay={400}
              />

              <StateResults
                changeResultsAmount={this.changeResultsAmount}
                results={this.state}
                index={this.algoliaConfig}
              />

              <SearchUiViewButtonList
                dropdown={dropdown}
                toggleDropdown={this.toggleDropdown}
                viewTitle={viewTitle}
                changeView={this.changeView}
                view={view}
                productResults={productResults}
                articleResults={articleResults}
              />
            </div>
          </div>

          <div className={view === `product` ? `main xlarge flex column` : `hide`}>
            {/* - We need to define the Product index on this level to gain control of the filters and configure the search correctly
                - Note: the <ArticleResults /> & <PageResults /> components have the indices defined inside them
                this.algoliaConfig.products
             */}
            <Index indexName={activeAlgoliaIndex}>
              <Configure
                filters={`${this.configureFilters}`}
                hitsPerPage={HITS_PER_RESULTS}
                distinct
              />
              <div
                id="sidebar-content"
                className="sidebar sidebar-mobile-view"
              >
                <div id="filterContainer">
                  <AlgoliaCollectionFilters
                    collection={this.props.collection}
                    collections={this.props.collections}
                    country={this.props.country}
                    navigationLevel={this.state.navigationLevel}
                    changeResultsIndex={this.changeResultsIndex}
                    setNumberRefinements={this.setNumberRefinements}
                    refinementCount={this.state.activeRefinements}
                    activeAlgoliaIndex={activeAlgoliaIndex}
                    enableSearchedFacets={false}
                    algoliaConfig={this.algoliaConfig}
                  />
                </div>
                <div className="flex v-center h-center back-button-wrapper">
                  <button
                    className="back-button small-show"
                    onClick={e => this.openFilters()}
                  >
                    Apply Filters
                  </button>
                </div>
              </div>
              <div className="listing-panel">
                <div className="body-component column column-12">
                  <div id="resultsContainer" className="results-container">
                    {isLoading && <LoadingIndicator />}
                    {!isLoading && (
                      <AlgoliaCollectionResults
                        collection={this.props.collection}
                        collections={this.props.collections}
                        country={this.props.country}
                        changeResultsIndex={this.changeResultsIndex}
                        resultsIndex={this.state.resultsIndex}
                        refinementCount={this.state.activeRefinements}
                        activeAlgoliaIndex={activeAlgoliaIndex}
                        algoliaConfig={this.algoliaConfig}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Index>
          </div>
          <div className={view === `article` ? `main xlarge flex column` : `hide`}>
            <ArticleFilters algoliaConfig={this.algoliaConfig} />
            <ArticleResults algoliaConfig={this.algoliaConfig} />
          </div>

          <div className={view === `page` ? `main xlarge flex` : `hide`}>
            <PageResults algoliaConfig={this.algoliaConfig} />
          </div>
        </InstantSearch>
      </div>
    )
  }
}
